<i18n>
en:
  disclaimer: getnext acts as marketplace between buyers and the artists. All purchases are concluded directly between these parties.
  whatis: What is getnext?
  imprint: Imprint

de:
  disclaimer: getnext (Fans & Fortune GmbH) dient nur als Vermittlerin. Der Vertrag wird zwischen Käufer*in und Künstler*in geschlossen!
  whatis: Was ist getnext?
  imprint: Impressum
</i18n>

<template>
  <div class="bg-white px-6 py-8">
    <p
      v-if="urlAlias && nickname"
      class="text-center text-sm text-gray-400 lg:pt-16"
    >
      <a :href="`/${urlAlias}/${$t('imprint').toLowerCase()}`" target="_blank">
        {{ nickname }} -
        {{ $t('imprint') }}
      </a>
    </p>
    <p class="text-center text-sm text-gray-400">
      {{ $t('disclaimer') }}
    </p>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
export default {
  computed: {
    nickname: sync('reward/nickname'),
    urlAlias: sync('reward/urlAlias')
  }
}
</script>
